import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { AppSidebarNav } from "./AppSidebarNav";
import { sygnet } from "src/assets/brand/sygnet";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import navigation from "../navigations/Menu";
import { setSidebarVisibility } from "src/redux/actions/planAction";
import { getAllDealers } from "src/redux/actions/customerAction";
import { useNavigate } from "react-router-dom";

const AppSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const unfoldable = useSelector((state) => state.sidebarUnfoldable);
  const { sidebarShow } = useSelector((state) => state?.planReducer);
  const { selectedRoleType } = useSelector((state) => state?.staffReducer);
  const [activeMenuItem, setActiveMenuItem] = useState("");
  const [navigationData, setNavigationData] = useState(navigation);
  const SchemaName = sessionStorage.getItem("schemaName");
  const obj = { schemaName: SchemaName };

  const handleMenuItemClick = (name) => setActiveMenuItem(name);

  useEffect(() => {
    dispatch(getAllDealers(obj));
  }, []);

  return (
    <CSidebar
      style={{ backgroundColor: "#2c2c2c" }}
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => dispatch(setSidebarVisibility(visible))}
    >
      <CSidebarBrand className="d-none d-md-flex bg-white" to="/">
        <img src="/logo.png" style={{ width: "30%", background: "#fff", borderRadius: 10 }} />
        <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav
            items={navigationData}
            activeMenuItem={activeMenuItem}
            onMenuItemClick={handleMenuItemClick}
            selectedRoleType={selectedRoleType}
          />
        </SimpleBar>
      </CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(AppSidebar);